import { action } from 'typesafe-actions';
import ActionTypes, { ActivePanel } from '../constants/general';
import { FurnitureEditorContext } from 'lib/constraintsChecker/FurnitureEditor';

export const toggleToggleCustomModeAction = (value: boolean) =>
  action(ActionTypes.SET_CUSTOM_MODE, { value });

export const setContextAction = (value: FurnitureEditorContext) =>
  action(ActionTypes.SET_CONTEXT, { value });

export const displayPiecesListAction = () =>
  action(ActionTypes.DISPLAY_PIECES_LIST);

export const displayViewerAction = (value: boolean) =>
  action(ActionTypes.DISPLAY_VIEWER, { value });

export const setColorsPanelAction = (value?: ActivePanel, openDefault = true) =>
  action(ActionTypes.SET_COLORS_PANEL, { value, openDefault });

export const setShelfModeAction = (value: boolean) =>
  action(ActionTypes.SET_SHELVES_MODE, { value });

export const openDoorsModeAction = (value: boolean) =>
  action(ActionTypes.OPEN_DOORS_MODE, { value });

export const switchLanguageAction = (code: string) =>
  action(ActionTypes.SWITCH_LANGUAGE, { code });

export const displayDimensionAction = (value: boolean) =>
  action(ActionTypes.DISPLAY_DIMENSION, { value });
